import { render, staticRenderFns } from "./FilterFieldset.vue?vue&type=template&id=c20478b6"
import script from "./FilterFieldset.vue?vue&type=script&lang=ts"
export * from "./FilterFieldset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports